var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 362.12 269.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f9b52c;\n      }\n\n      .cls-2 {\n        fill: #027878;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M181.06,269.32l181.06-80.16-45.21-67.05-19.34-16.02,50.5,77.39-17.23,1.14c-63.9,4.25-144.9,57.81-145.71,58.35l-4.07,2.71-4.07-2.71c-.81-.54-81.81-54.11-145.71-58.35l-17.23-1.14,50.5-77.39-19.34,16.02L0,189.17l181.06,80.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.06,233.27s82.69-58.86,149.32-63.58l-42.08-61.3s-67.01-17.45-107.24,44.08c-40.23-61.52-107.24-44.08-107.24-44.08l-42.08,61.3c66.63,4.72,149.32,63.58,149.32,63.58Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "199.04 11.6 191.32 35.36 166.33 35.36 186.55 50.05 178.82 73.82 199.04 59.13 219.26 73.82 211.53 50.05 231.75 35.36 206.76 35.36 199.04 11.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.58,44.63c0-20.89,14.36-38.42,33.74-43.28-3.81-.87-7.77-1.34-11.84-1.34-29.3,0-53.05,23.75-53.05,53.05s23.75,53.05,53.05,53.05c17.51,0,33.03-8.48,42.69-21.56-6.01,3.01-12.78,4.71-19.96,4.71-24.65,0-44.63-19.98-44.63-44.63Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpin);
export default __webpack_public_path__ + "static/media/spin.78ef971433204e8fc5528806dc230991.svg";
export { ForwardRef as ReactComponent };